var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-long-banner mv4"},[_c('a',{attrs:{"href":_vm.ad.TargetUrl,"target":"_blank"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.ad.ImagePath,"alt":"banner"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }